




















































































































































































































/* eslint-disable */
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { Apis, Services, Factories } from '@finx/web-repository'
import { Plantao, PlantaoProcedimento } from '@/types/_'
import { Provisao } from '@finx/web-repository/src/types/Provisao'

@Component

export default class ViewPlantao extends Vue {
  dateFormatted: any = this.formatDate(new Date().toISOString().substr(0, 10))
  showDate: Boolean = false

  user: any = {}

  loading: any = {
    status: false,
    text: 'Carregando...',
  }

  snackbar: any = {
    disabled: true,
    message: '',
    show: false,
    top: false,
    timeout: 60000,
  }

  autocompletLoadings: any = {
    getFontesPagadorasLoad: false,
    getLocaisExecucoesLoad: false,
    getProcedimentosLoad: false
  }

  alert: any = {
    show: false,
    message: '',
  }

  alertModal = {
    show: false,
    to: '',
    message: '',
    error: false,
    buttons: [
      {
        text: 'Provisão salva!',
        action: '/provisao',
        color: 'primary',
      },
    ],
    icon: '',
    iconColor: '',
    subtitle: '',
    title: '',
  }

  procedimentosApi: any[] = []

  plantao: Plantao = {
    fontePagadora: '',
    localExecucao: '',
    operadora: '',
    data: new Date().toISOString().substr(0, 10),
    fontePagadoraMessageError: [],
    localExecucaoMessageError: [],
    dataMessageError: [],
    procedimentos: []
  }

  procedimento: PlantaoProcedimento = {
    sequencial: 1,
    quantidade: 1,
    quantidadeMessageError: [],
    procedimentoMessageError: [],
    procedimentoSelected: ''
  }

  fontesPagadoras: any[] = []
  locaisExecucoes: any[] = []

  get getDateFormatted() {
    return this.dateFormatted
  }

  set getDateFormatted(value) {
    this.dateFormatted = value
  }

  get getDate() {
    return this.getPlantao.data
  }

  set getDate(value) {
    this.getDateFormatted = this.formatDate(value)
    this.getPlantao.data = value
  }

  get getPlantao() {
    return this.plantao
  }

  set getPlantao(value) {
    this.plantao = value
  }

  get getFontesPagadoras() {
    return this.fontesPagadoras
  }

  set getFontesPagadoras(value) {
    this.fontesPagadoras = value
  }

  get fontePagadora() {
    return this.getPlantao.fontePagadora
  }

  set fontePagadora(value) {
    this.plantao.fontePagadora = value
    new Promise(async (resolve) => {
      await this.getLocaisExecucoesLoad().then((e) => resolve(e))
    })
  }

  get getLocaisExecucoes() {
    return this.locaisExecucoes
  }

  set getLocaisExecucoes(value) {
    this.locaisExecucoes = value
    this.procedimentosApi = []
    this.getPlantao.procedimentos = []
    this.getPlantao.procedimentos.push({ ...this.procedimento })
  }

  get localExecucao() {
    return this.getPlantao.localExecucao
  }

  set localExecucao(value) {
    this.getPlantao.localExecucao = value
    new Promise(async (resolve) => {
      await this.getOperadorasLoad().then((e) => resolve(e))
    })
  }

  get getProcedimentosApi() {
    return this.procedimentosApi
  }

  set getProcedimentosApi(value) {
    this.procedimentosApi = value
  }

  async getUser() {
    this.user = this.$user
  }

  addProcedimento() {
    let p = { ...this.procedimento }
    p.sequencial = this.getPlantao.procedimentos.length + 1
    this.getPlantao.procedimentos.push(p)
  }

  removeProcedimento(index) {

    this.getPlantao.procedimentos.splice(index, 1)

    for (let i = 0; i < this.getPlantao.procedimentos.length; i++) {
      this.getPlantao.procedimentos[i].sequencial = i + 1;
    }
  }

  formatDate(date) {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
  }

  redirectAlertModal(redirect) {
    this.$router.push(`/${redirect}`)
  }

  async getFontesPagadorasLoad() {
    this.autocompletLoadings.getFontesPagadorasLoad = true
    this.alert.show = false

    const request = await
    Apis.Contratos.FontesPagadoras.getFontesPagadorasByUserId(this.user.profile.sub, true)
    const success = Factories.Apis.success(request)

    if (success) {
      if (request.data.length > 0) {
        this.getFontesPagadoras = request.data
      } else {
        this.snackbar.message = 'Fonte pagadora não encontrado.'
        this.snackbar.show = true
      }
    } else {
      this.alert.show = true
      this.alert.message = Factories.ErrorMessage(request)
    }

    this.autocompletLoadings.getFontesPagadorasLoad = false
  }

  async getLocaisExecucoesLoad() {
    this.autocompletLoadings.getLocaisExecucoesLoad = true
    this.alert.show = false

    if (this.getPlantao.fontePagadora !== undefined) {
      const request = await
      Apis.Contratos.LocaisExecucoes.getLocaisExecucoesByContratoId(this.getPlantao.fontePagadora.contratoId)
      const success = Factories.Apis.success(request)

      if (success) {
        if (request.data.length > 0) {
          this.getLocaisExecucoes = request.data
        } else {
          this.snackbar.message = 'Local execução não encontrado.'
          this.snackbar.show = true
        }
      } else {
        this.alert.show = true
        this.alert.message = Factories.ErrorMessage(request)
      }
    }

    this.autocompletLoadings.getLocaisExecucoesLoad = false
  }

  async getOperadorasLoad() {
    if (this.getPlantao.fontePagadora !== undefined && this.localExecucao !== undefined) {
      const request = await
      Apis.Contratos.Operadoras.getOperadorasByFilters(this.getPlantao.fontePagadora.contratoId, this.localExecucao.localExecucaoId)
      const success = Factories.Apis.success(request)

      if (success) {
        this.getPlantao.operadora = request.data[0]
        await this.getProcedimentosLoad()
      }
    }
  }

  async getProcedimentosLoad() {
    this.autocompletLoadings.getProcedimentosLoad = true
    this.alert.show = false

    const request = await
    Apis.Contratos.Procedimentos.getProcedimentosByContrato(this.getPlantao.fontePagadora.contratoId,
      this.getPlantao.operadora.contratoGrupoRemuneracaoId,
      this.localExecucao.localExecucaoId,
      this.getPlantao.operadora.operadoraId, '')

    const success = Factories.Apis.success(request)

    if (success) {
      this.getProcedimentosApi = request.data
      this.getProcedimentosApi.map(c => c.descricaoCompleta = c.codigo + ' - ' + c.descricao)
    } else {
      this.alert.show = true
      this.alert.message = Factories.ErrorMessage(request)
    }

    this.autocompletLoadings.getProcedimentosLoad = false
  }

  validInputProcedimento(procedimento, message) {
    if (procedimento.procedimentoSelected !== undefined && procedimento.procedimentoSelected !== '') {
      procedimento.procedimentoMessageError = []
    } else {
      procedimento.procedimentoMessageError = [message]
    }
  }

  validInputQuantidade(procedimento, message) {
    if (procedimento.quantidade !== undefined && procedimento.quantidade !== '') {
      procedimento.quantidadeMessageError = []
    } else {
      procedimento.quantidadeMessageError = [message]
    }
  }

  validInput(input, message) {
    if (this.getPlantao[input] !== undefined && this.getPlantao[input] !== '') {
      this.getPlantao[`${input}MessageError`] = []
    } else {
      this.getPlantao[`${input}MessageError`] = [message]
    }
  }

  validForm() {
    let valid: boolean = true

    if (this.getPlantao.fontePagadora === undefined || this.getPlantao.fontePagadora === '') {
      this.getPlantao.fontePagadoraMessageError = ['Informar fonte pagadora']
      valid = false
    } else {
      this.getPlantao.fontePagadoraMessageError = []
    }

    if (this.getPlantao.localExecucao === undefined || this.getPlantao.localExecucao === '') {
      this.getPlantao.localExecucaoMessageError = ['Informar local execução']
      valid = false
    } else {
      this.getPlantao.localExecucaoMessageError = []
    }

    if (this.getPlantao.data === undefined || this.getPlantao.data === '') {
      this.getPlantao.dataMessageError = ['Informar data']
      valid = false
    } else {
      this.getPlantao.dataMessageError = []
    }

    this.getPlantao.procedimentos.map((c) => {
      const temp = c
      if (temp.procedimentoSelected === '') {
        temp.procedimentoMessageError = ['Informar procedimento']
        valid = false
      } else {
        temp.procedimentoMessageError = []
      }
      if (temp.quantidade === undefined || temp.quantidade === '') {
        temp.quantidadeMessageError = ['Informar quantidade']
        valid = false
      } else {
        temp.quantidadeMessageError = []
      }
      return temp
    })

    return valid
  }

  async save() {
    if (this.validForm()) {
      this.loading.status = true

      if (this.$route.params.action === 'editar') {
        await this.update()
      } else {
        await this.post()
      }

      this.loading.status = false
    }
  }

  async update() {
    this.loading.text = 'Atualizando plantão...'
    const paramPost = this.buildProvisao()
    const request = await Apis.Legacy.Producao.updateProducao(paramPost)
    const success = Factories.Apis.success(request)

    if (success) {
      this.alertModal.show = true
      this.alertModal.to = 'producao'
      this.alertModal.message = 'Plantão atualizado com sucesso'
    } else {
      this.snackbar.message = Factories.ErrorMessage(request)
    }
  }

  async post() {
    this.loading.text = 'Salvando plantão...'
    const paramPost = this.buildProvisao()

    const request = await Apis.Legacy.Producao.saveProducaoV2(paramPost)
    const success = Factories.Apis.success(request)

    if (success) {
      this.$ga.event('plantao', 'adicionar', this.$user.profile.email)
      this.alertModal.show = true
      this.alertModal.to = 'producao'
      this.alertModal.message = 'Plantão salvo com sucesso'
    } else {
      this.snackbar.show = true
      this.snackbar.message = Factories.ErrorMessage(request)
    }
  }

  buildProvisao() {
    const provisao: Provisao = {
      identificador: this.$route.params.plantaoId,
      contratoId: this.getPlantao.fontePagadora.contratoId,
      acomodacao: null,
      urgente: null,
      nomePaciente: 'Plantão',
      dataRealizacao: this.getPlantao.data,
      prestadorId: this.getPlantao.fontePagadora.prestadorId,
      fontePagadoraId: this.getPlantao.fontePagadora.fontePagadoraId,
      localExecucaoId: this.getPlantao.localExecucao.localExecucaoId,
      operadoraId: this.getPlantao.operadora.operadoraId,
      planoOperadoraNome: null,
      planoOperadoraId: null,
      profissionaisExecutantes: [],
      procedimento: [],
    }

    provisao.profissionaisExecutantes.push({ id: this.user.profile.sub, funcao: 0 })

    provisao.procedimento = this.getPlantao.procedimentos.reduce((target, source) => {
      target.push({
        contratoProcedimentoId: source.procedimentoSelected.id,
        codigo: source.procedimentoSelected.codigo,
        acomodacao: null,
        descricao: source.procedimentoSelected.descricao,
        quantidade: Number.parseInt(source.quantidade, 10),
        sequencial: source.sequencial,
        urgente: null,
        viaAcesso: null,
        invasivo: true,
        previsaoRecebimento: '2020-04-15T15:00:00',
        prazoRecebimento: 2,
        quantidadeAuxiliarPermitido: 0,
      })
      return target
    }, [] as any[])

    return provisao
  }

  async init() {
    this.loading.status = true
    this.loading.text = 'Carregando...'
    if (this.$route.params.action === 'editar') {
      await Apis.Legacy.Producao.getProducaoById(this.$route.params.plantaoId).then(async (request) => {
        await this.getFontesPagadorasLoad().then(async () => {
          const [fontePagadoraTemp] = this.getFontesPagadoras
            .filter(p => p.contratoId === request.data.contratoId
              && p.fontePagadoraId === request.data.fontePagadoraId
              && p.prestadorId === request.data.prestadorId)[0]

          this.fontePagadora = fontePagadoraTemp

          await this.getLocaisExecucoesLoad().then(async () => {
            const [localExecucaoTemp] = this.getLocaisExecucoes
              .filter(p => p.localExecucaoId === request.data.localExecucaoId)[0]

            this.localExecucao = localExecucaoTemp

            await this.getOperadorasLoad().then(async () => {
              const procedimentosSort = request.data.procedimentos.sort((n1, n2) => {
                if (n1.sequencial > n2.sequencial) {
                  return 1
                }
                if (n1.sequencial < n2.sequencial) {
                  return -1
                }
                return 0
              })

              this.getPlantao.procedimentos = []

              for (let i = 0; i < procedimentosSort.length; i++) {
                const element = procedimentosSort[i]
                const procedimentoApi = this.getProcedimentosApi.filter(c => c.id === element.contratoProcedimentoId)
                this.getPlantao.procedimentos.push({
                  sequencial: element.sequencial,
                  quantidade: element.quantidade,
                  procedimentoSelected: procedimentoApi[0],
                } as PlantaoProcedimento)
              }
            })
          })
        })
      })
    } else {
      await this.getFontesPagadorasLoad().then(() => {
        this.getPlantao.procedimentos.push({
          ...this.procedimento,
        })
      })
    }

    this.loading.status = false
  }

  async mounted() {
    await this.getUser()
    await this.init()
  }
}
